<template>
<div id="wire-syndication-widget-anchor" class="wire-syndication-widget-wrapper">
    <link href='https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap' rel='stylesheet' type='text/css'>
    <link href='https://fonts.googleapis.com/css?family=Domine:400,700&display=swap' rel='stylesheet' type='text/css'>
    <div v-if="Object.keys(post).length > 0" class="widget_slot loaded">
        <div class="rec-widget-header" style="background-color:#dc0000;">
            <div class="heading-image">
                <img src="https://www.realclearwire.com/asset/img/rcwr-home-logo.png">
            </div>
            <div class="rec-title" style="color:#ffffff;">Recommended</div>
        </div>
        <div class="rec-link-body" data-id="2">
            <div class="rec-image">
                <a class="rec-image-anchor" 
                    :href="`${urlPrefix}${post.link}?utm_campaign=rcwire_adfill&utm_source=recommended&utm_term=${encodeURIComponent(post.title)}`"
                    :style="`background-image: url(${getImage(post.third_party_image.url)});`"
                    target="_parent"
                    >
                    <div class="bg-text">
                        <div class="bg-text-title" v-html="post.title" ></div>
                        <!-- <div class="bg-text-byline" v-html="getByline(post)" ></div> -->
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import jquery from 'jquery';
export default {
    name: 'syndication-widget',
    data() {
        return {
            post: {},
            loading: false,
        }
    },
    created(){

        (async () => {
            this.loading = true;
            await this.loadPost();
            this.loading = false;
        })();

    },
    computed: {

        urlPrefix(){

            let scripts = Array.from(document.querySelectorAll('script[src*="/asset/dist/rcwr/syndication_widget.js"]'));

            if( Array.isArray(scripts) && scripts.length > 0 ){
                var myScript = scripts[scripts.length - 1];
            
                if( myScript.getAttribute("data-click-url") ) {
                    return myScript.getAttribute("data-click-url");
                }
            }

            return '';
        },

    },
    methods: {

        getImage(img_url){

            if( img_url.indexOf('_6_') > -1 ){
                return img_url.replace('_6_', '_4_');
            }

            return img_url.replace('_5_', '_4_');
        },

        loadPost(){
            return new Promise((resolve, reject) => {
                var now_time = new Date().getTime();
                now_time = Math.floor(now_time / 100000);
                jquery.ajax({
                    crossDomain: true,
                    url: `https://realclearwire.com/syndications/realclearwire_ads/index.jsonp?v=${now_time}`,
                    dataType: 'jsonp',
                    jsonp: 'callback',
                    jsonpCallback: 'callback_realclearwire_ads_12',
                    success: (data) => {

                        // console.log("SYNDICATION WIDGET DATA", data);
                        let posts = data.posts.map((p, i) => {
                            if(p.third_party_image){
                                return p;
                            }
                        });

                        if(posts[0]){
                            this.$set(this, 'post', posts[0]);
                        }

                        resolve(data);
                    },
                    error: () => {
                        reject();
                    },
                });
            });
        },

        getByline(post){

            let byline = "";

            if( Array.isArray(post.authors) && post.authors.length > 0){

                let authorCount = post.authors.length;

                for (let index = 0; index < post.authors.length; index++) {

                    let author = post.authors[index];

                    let authorRemaining = authorCount - (index + 1);

                    byline += author.fullname;

                    if( authorRemaining > 1 ){
                        byline += " &#44; ";
                    }else if( authorRemaining == 1){
                        byline += " &amp; ";
                    }
                }
            }

            if(post.publication !== null){

                if( Array.isArray(post.authors) && post.authors.length > 0){
                    byline += ", ";
                }

                byline += post.publication.name;
            }

            if( byline.length > 0 ){
                byline = "By "+byline;
            }

            return byline;
        },
    },
};
</script>

<style lang="scss">
@import "../../css/CssReset.css";

.wire-syndication-widget-wrapper{
    // margin-bottom: 20px;
    font-family: 'ROBOTO', sans-serif;

    .widget_slot{
        overflow: hidden;
        font-weight: bold;
        font-size: 0.9em;
        position: relative;
        // margin-bottom: 20px;

        .rec-widget-header{
            display: flex;
            align-content: center;
            align-items: center;
            height: 55px;
            background-color: #d30015;
            background-repeat: no-repeat;

            .heading-image{
                padding-left: 15px;

                img{
                    padding: 5px;
                    width: 100px;
                    background-color: #fff;
                }
            }

            .rec-title{
                padding: 0px 0px 0px 15px;
                display: inline-block;
                width: auto;
                color: #FFFFFF;
                float: left;
            }
        }

        .rec-link-body{
            border-bottom: 1px solid #EBEBEB;
            /* padding: 0 0 10px 0; */
            overflow: auto;
            position: relative;
            background-color: #fff;

            .rec-image{
                height: 175px;
                width: 100%;
                position: relative;
                overflow: hidden;
                line-height: 0.9em;

                .rec-image-anchor{
                    font-size: 1em;
                    text-decoration: none;
                    color: #d30015;
                    background-size: cover;
                    display: block; 
                    height: 100%;
                    position: relative;

                    .bg-text{
                        color: #fff;
                        display: flex;
                        // justify-content: center;
                        justify-content: flex-end;
                        align-items: flex-start;
                        height: 100%;
                        flex-direction: column;
                        background-color: rgb(0 0 0 / 30%);

                        .bg-text-title{
                            padding: 10px 20px;
                            font-size: 1.3em;
                            line-height: 1.6;
                        }

                        .bg-text-byline{
                            padding: 10px 20px;
                            font-size: 1.0em;
                            line-height: 1.6;
                        }
                    }
                }
            }
        }
    }
}
</style>